export const FETCH_WORKER_REQUEST = 'FETCH_WORKER_REQUEST'
export const FETCH_WORKER_SUCCES = 'FETCH_WORKER_SUCCES'
export const FETCH_WORKER_ERROR = 'FETCH_WORKER_ERROR'


// WEBPACK FOOTER //
// ./src/constants/Worker.js